import React, { Component } from 'react'
import List from '../../old_Components/JobApplicationList/JobApplicationList';
import constant from '../../constant';
import queryString from 'query-string';
import { capitalizeWords, getStorage, setStorage } from '../../utils';
import ModalWindow from '../../old_Components/Common/ModalWindow1';
import OtpInput from 'react-otp-input';
import EnterSecurityCode from '../../old_Components/Common/EnterSecurityCode';
import { verifySecurityCode } from '../../action/securitypin';
import moment from 'moment';
import { isATSEnabled } from '../../action/auth';
export default class JobApplicationList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      LIMIT: 10,
      PAGE: 1,
      SELECTION_PROCESS: undefined,
      COUNT: undefined,
      LIST: undefined,
      KEYWORD: '',
      JOB_TITLE: '',
      status: undefined,
      ATS_ENABLED: 0
    }
  }

  componentDidMount() {
    const qParam = queryString.parse(this.props?.location?.search)
    this.setState({ JOB_TITLE: capitalizeWords(qParam.job.split('-')).join(' '), SELECTION_PROCESS: qParam.s })
    document.title = capitalizeWords(qParam.job.split('-')).join(' ') + ' Applications - Hiring.JobzShala.com'
    this.setState({
      FILTER_BY: qParam.f,
      PAGE: qParam.p,
      LIMIT: qParam.l,
      KEYWORD: qParam.k,
    })

    isATSEnabled().then(res => {
      if (res.status) {
        this.setState({ ATS_ENABLED: res.result })
      }
    })
  }

  onLimitChange = (input) => {
    const qParam = queryString.parse(this.props?.location?.search)
    window.location.href = constant.component.JobApplicationList.url + `?job=${qParam.job}&id=${qParam.id}&l=${input}&p=${qParam.p}&s=${qParam.s}`
  }
  onPageChange = (input) => {
    const qParam = queryString.parse(this.props?.location?.search)
    window.location.href = constant.component.JobApplicationList.url + `?job=${qParam.job}&id=${qParam.id}&l=${qParam.l}&p=${input}&s=${qParam.s}`
  }
  onSubmitPIN = (PIN) => {
    debugger
    verifySecurityCode(PIN).then(res => {
      if (res.status) {
        if (res.result) {
          setStorage(constant.keys.Job_Responses_Session, moment().format('X'))
          window.location.reload()
        }
        else {
          this.setState({ status: 'Enter Correct PIN' })

        }
      }
    })
  }
  render() {
    const { FILTER_BY, LIMIT, PAGE, COUNT, LIST, SELECTION_PROCESS, JOB_TITLE, status, ATS_ENABLED } = this.state
    const qParam = queryString.parse(this.props?.location?.search)
    return (
      <React.Fragment>
        {/* {!getStorage(constant.keys.Job_Responses_Session) && <ModalWindow>
          <EnterSecurityCode
            status={status}
            onSubmitPIN={(PIN) => this.onSubmitPIN(PIN)}
          />
        </ModalWindow>} */}
        { <List
          ATS_ENABLED={ATS_ENABLED}
          PAGE={qParam.p}
          LIMIT={qParam.l}
          SELECTION_PROCESS={qParam.s}
          KEYWORD={qParam.k}
          JOB_ID={qParam.id}
          JOB_TITLE={JOB_TITLE}
          // onFilterChange={(filter) => this.onFilterChange(filter)}
          onLimitChange={(limit) => this.onLimitChange(limit)}
          onPageChange={(page) => { this.onPageChange(page) }}
        />}
      </React.Fragment>
    )
  }
}
